import * as React from 'react'
import { Buttons, Popup, PopupFormWrapper, SelectFormField, SelectOptionModel } from 'traveldesk-ui'

interface Props {
    externalCategoryId: string
    externalCategoryName: string
    categoriesOptions: SelectOptionModel[]
    onCancel: () => void
    onCategorySelected: (categoryId: number) => void
}

const CategoryMappingForm: React.FC<Props> = ({
    externalCategoryId,
    externalCategoryName,
    categoriesOptions,
    onCancel,
    onCategorySelected,
}) => {
    const [selectedCategoryId, setSelectedCategoryId] = React.useState<number>(0)

    return (
        <Popup onClose={onCancel}>
            <PopupFormWrapper>
                <h3>Map Category: {externalCategoryName} ({externalCategoryId})</h3>
                <SelectFormField
                    options={categoriesOptions}
                    value={selectedCategoryId}
                    onChange={(option: SelectOptionModel) => setSelectedCategoryId(option.value as number)}
                />
                <Buttons.ButtonSmallGreen
                    disabled={!selectedCategoryId}
                    onClick={() => onCategorySelected(selectedCategoryId)}
                >
                    Save mapping
                </Buttons.ButtonSmallGreen>
            </PopupFormWrapper>
        </Popup>
    )
}

export default CategoryMappingForm
